// FOR review button
  document.querySelector('.scroll-to-reviews').addEventListener('click', function (e) {
    e.preventDefault(); // Prevent the default jump
    document.querySelector('#reviews').scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });

// ---------------------------

document.querySelector('.scroll-to-reviews1').addEventListener('click', function (e) {
  e.preventDefault(); // Prevent the default jump
  document.querySelector(' #review1').scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
});

$('.product__media-list-wrapper .product__media-subitem .product__media').click(function(e) {
  $(this).parents().find(".deferred-media__poster").trigger("click");
  $('video').trigger('play');
});




// Slick Slider You may also like

//   $('.abz_product-recommendations__list').slick({
//   infinite: true,
//   slidesToShow: 3,
//   slidesToScroll: 3
// });




